// extracted by mini-css-extract-plugin
module.exports = {"container":"stream_container__2AT1J"};